import * as React from 'react';
import { FiClock } from 'react-icons/fi';
import { merge } from '../../helpers/Utility';
import { Icon } from '../shared/icons/Icon';
import { withField } from './withField';

interface InjectedProps {
  value: string | undefined;
  onChange: (newValue: string | undefined) => void;
}

interface Props {
  name: string;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
}

export const TimeInput = React.forwardRef<HTMLInputElement, Props & InjectedProps>(
  ({ className, name, onChange, value, placeholder, disabled, ...props }, ref) => {
    const outerClass = merge('flex items-center relative', className);

    let innerClass =
      'w-full shadow-sm pl-10 focus:ring-primary-500 bg-primary-std focus:border-primary-500 font-medium border-primary-std rounded-md relative';
    if (disabled) {
      innerClass = merge(innerClass, 'bg-gray-200');
    }

    return (
      <div className={outerClass}>
        <Icon className="absolute left-3 z-10 pointer-events-none" small Icon={FiClock} />
        <input
          {...props}
          ref={ref}
          type="time"
          id={name}
          name={name}
          disabled={disabled}
          placeholder={placeholder}
          value={value ?? ''}
          onChange={e => onChange(e.target.value)}
          className={innerClass}
        />
      </div>
    );
  }
);

export const TimeField = withField<string | undefined, Props>(TimeInput);
